import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class SchoolRegistrationUnderVerificationService {
    private url = AppSettings.API_ENDPOINT_V3;
    private getRegistrationQuestionnaire = apiConstants.getRegistrationQuestionnaire;
    private schoolQuestionnaireAnswer = apiConstants.schoolQuestionnaireAnswer;
    constructor(private http: HttpClient) { }
    headers: HttpHeaders;
    getRegistrationQuestionnaireApi(authToken: any) {
        const headers = new HttpHeaders().append("token", authToken);
        return this.http.get(`${this.url}${this.getRegistrationQuestionnaire}/?lang=en`, { headers }).pipe(map(res => res));
    }
    schoolQuestionnaireAnswerApi(authToken: any, body: any) {
        const headers = new HttpHeaders().append("token", authToken);
        return this.http.post(`${this.url}${this.schoolQuestionnaireAnswer}`, body, { headers }).pipe(map(res => res));
    }
}